import ConcertBox from '@/components/concerts';
import Layout from '@/layouts/layout';

export default function Concerts({ events }) {
    return (
        <Layout>
            {events.data.length > 0 && (<ConcertBox concerts={events.data} />)}
            {events.data.length == 0 && (
                <div className='flex text-lg justify-center'>
                    Nothing currently scheduled
                </div>
            )}
        </Layout>
    );
}


